import React, { createContext, useContext, useState } from "react";

import { IDnaWorkflow, IDnaWorkflowStep, IDnaWorkflowStepConfiguration } from "../interface/interface";

export const dnaWorkflowContext = createContext<any>(null);

export const DnaWorkflowContextProvider = ({ children }) => {
    const [selectedDnaWorkflows, setSelectedDnaWorkflows] = useState<IDnaWorkflow[]>([]);
    const [selectedDnaWorkflowSteps, setSelectedDnaWorkflowSteps] = useState<IDnaWorkflowStep[]>([]);
    const [selectedDnaWorkflowStepConfigurations, setSelectedDnaWorkflowStepConfigurations] = useState<IDnaWorkflowStepConfiguration[]>([]);
    return (
        <dnaWorkflowContext.Provider
            value={{
                selectedDnaWorkflows,
                setSelectedDnaWorkflows,
                selectedDnaWorkflowSteps,
                setSelectedDnaWorkflowSteps,
                selectedDnaWorkflowStepConfigurations,
                setSelectedDnaWorkflowStepConfigurations,
            }}
        >
            {children}
        </dnaWorkflowContext.Provider>
    );
};

export const useDnaWorkflows = (): IUseDnaWorkflows => {
    const {
        selectedDnaWorkflows,
        setSelectedDnaWorkflows,
        selectedDnaWorkflowSteps,
        setSelectedDnaWorkflowSteps,
        selectedDnaWorkflowStepConfigurations,
        setSelectedDnaWorkflowStepConfigurations,
    } = useContext(dnaWorkflowContext);

    return {
        selectedDnaWorkflows,
        setSelectedDnaWorkflows,
        selectedDnaWorkflowSteps,
        setSelectedDnaWorkflowSteps,
        selectedDnaWorkflowStepConfigurations,
        setSelectedDnaWorkflowStepConfigurations,
    };
};

interface IUseDnaWorkflows {
    selectedDnaWorkflows: IDnaWorkflow[];
    setSelectedDnaWorkflows: React.Dispatch<React.SetStateAction<IDnaWorkflow[]>>;
    selectedDnaWorkflowSteps: IDnaWorkflowStep[];
    setSelectedDnaWorkflowSteps: React.Dispatch<React.SetStateAction<IDnaWorkflowStep[]>>;
    selectedDnaWorkflowStepConfigurations: IDnaWorkflowStepConfiguration[];
    setSelectedDnaWorkflowStepConfigurations: React.Dispatch<React.SetStateAction<IDnaWorkflowStepConfiguration[]>>;
}
